import React from "react";
import { useTranslation } from 'react-i18next';
import "../layout/sec4.css";
import ic from '../../asserts/ic.png';

import IM8 from "../../asserts/IM8.png";
import IM9 from "../../asserts/IM9.png";
import IMG1 from "../../asserts/sec4-img.png";
import IMG2 from "../../asserts/sec4-img1.png";
import Sec4Card from "../common/Sec4Card";
import Btn1 from "../common/btn1";

const Sec4 = () => {
  const { t } = useTranslation();
  return (
    <section className="sec4">
      <div className="sec4-container">
        <div className="sec4-left">

          <div className="badge">{t('sec4_badge')}</div>

          <h2 className="sec4-main-title">{t('sec4_title_spann')}
             <br />
            <span className="sec4-title1">{t('sec4_title_span')}</span>
          </h2>

          <p className="sec4-text">
            {t('sec4_text1')}
          </p>

          <p className="sec4-text">
            {t('sec4_text2')}
          </p>
          <Btn1 b='btn1' btntt={t('sec4_btn_more')} ic={ic} />
          <div className="sec4-circle"></div>

        </div>

        <div className="sec4-right">
          <div className="sec4-grid">
            <Sec4Card img={IM8} alt="" title={t('sec4_card1_title')} text={t('sec4_card1_text')} />

            <img src={IMG2} className="sec4-side-img1" alt="" />
            <img src={IMG1} className="sec4-side-img" alt="" />



            <Sec4Card img={IM9} alt="" title={t('sec4_card2_title')} text={t('sec4_card2_text')} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Sec4;